import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE } from "../../../../../../theme/Component/BasicTable";
import { _AssignedMaintenanceType, _single, _WorkMaintenanceOrder } from "../../../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { SelectWorkMaintenanceOrderConstants } from "./Selectores/SelectWorkMaintenanceOrderConstants";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { FixedAssetReplacementByWorkMaintenance } from "./FixedAssetReplacementByWorkMaintenance";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { SelectFixedAsset } from "../FixedAsset/SelectFixedAsset";
import { EditorFixedAssetItem } from "../EditorFixedAssetItem";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { RequestMaintenance } from "../../../../../../Factoty&Production/Maintenance/RequestMaintenance/RequestMaintenance";
import { InputDate } from "../../../../../../theme/Input/InputDate";

const ALIVE = 0;
const DELETED = 1
const DRAFT = 7
const COMPLETE = 8
const PENDING_FOR_REPLACEMENT = 2
const NOT_IN_INVENTORY = 4

interface Formdata {
    idFixedAsset: number;
    idItem: number;
    internalCode: string;
    procedureCode: string;
    state: number;
    From: any;
    Upto: any;
}

export const WorkMaintenanceOrder = () => {
    const { instance, lista, bean, setBean, setLista } = useDataBean(_WorkMaintenanceOrder)
    const paginador = usePaginator();

    const modalReplacement = useModal(`Catalogo de Repuestos Realizados de ${bean.Name}`, MODAL_md);
    const modalAdd = useModal(`Confrimar Cambiar estado de ${bean.Name}`, MODAL_md);
    const modalCreate = useModal(`Crear orden de trabajo`, MODAL_md);
    const modalClose = useModal(`Confrimar Cambiar estado de ${bean.Name}`, MODAL_md);
    const modalHistory = useModal(`Historial de Mantenimientos de ${bean.TechnicianName}`, MODAL_XL);
    const modalDelete = useModal(`Eliminar Orden ${bean.TechnicianName}`, MODAL_SM);


    const [form, setForm] = useState<Partial<Formdata>>({})

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        let Props: any = {}

        if (form.state) Props.State = form.state
        if (form.idFixedAsset) Props.FixedAssetID = form.idFixedAsset
        if (form.idItem) Props.IDItem = form.idItem
        if (form.internalCode) Props.FixedAssetItemCode = form.internalCode
        if (form.procedureCode) Props.ProcedureCode = form.procedureCode


        instance.getWorkMaintenanceOrderRender(paginador.page, 15, Props, form.From, form.Upto).then(
            (resp: any) => {
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;

                    data.AccountEntityData = `${data.AccountNit ?? ""} - ${data.AccountEntity}`
                    data.FAAccountEntity = data.FAAccountNit ? `${data.FAAccountNit ?? ""} - ${data.FAAccountEntity}` : "N/P"
                    data.FAEntity = data.FixedAssetID ? `${data.FixedAssetID} - ${data.FixedAssetDescription}` : "N/P"
                });
                setLista(resp.List);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            State: 2
        });
        modalCreate.open();
    }

    const iconButtonsItem = [
        { nombre: 'Crear Solicitud', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDWorkMaintenanceOrder', visible: true },
        { title: 'Guia de Mantenimiento Asignado', property: 'ProcedureCode', visible: true },
        { title: 'Maquina', property: 'FAEntity', visible: true },
        { title: 'Codigo Interno', property: 'FixedAssetItemCode', visible: true },
        { title: 'Responsable', property: 'FAAccountEntity', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Responsable', property: 'AccountEntityData', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Consultar Catalogo de Repuestos Realizados', icono: 'ri-file-settings-line', visible: true, evento: () => { modalReplacement.open() } },
            { titulo: 'Historial del Procedimiento', icono: 'ri-list-check', visible: bean.IDRequestMaintenance, evento: () => { modalHistory.open() } },
            { titulo: 'Adicionar mas Solicitudes de materiales', icono: 'ri-file-add-line', visible: bean.State != 1 && bean.State != 7 && bean.State != 2, evento: () => { modalAdd.setModal({ ...modalAdd.modal, view: true, name: "Confrimar Cambiar estado" }) } },
            { titulo: 'Solicitar Implementos', icono: 'ri-file-add-line', visible: !bean.IDItem && bean.State == 7, evento: () => { modalAdd.setModal({ ...modalAdd.modal, view: true, name: "Confrimar Cambiar estado" }) } },
            {
                titulo: 'Finalizar Orden', icono: 'ri-file-reduce-line', visible: (
                    bean.State === PENDING_FOR_REPLACEMENT ||
                    bean.State === DRAFT ||
                    bean.State === ALIVE
                ), evento: () => { modalClose.setModal({ ...modalClose.modal, view: true, name: "Confrimar Cambiar estado" }) }
            },
            { titulo: 'Eliminar Orden', icono: 'ri-delete-bin-line', visible: bean.State == DRAFT, evento: () => { modalDelete.open() } },
        ];

        return <ListMenu listaBotones={botones} />;
    };

    const updateWorkOrder = (Sttate: number) => {
        instance.updateWorkMaintenanceOrder({ ...bean, State: Sttate }).then(
            (resp) => {
                getLista();
                modalAdd.close();
                modalClose.close();
                modalDelete.close();
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const createOrder = () => {
        instance.updateWorkMaintenanceOrder(bean).then(
            (resp) => {
                modalCreate.close();
                getLista();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <BasicPage titulo="Ordenes de Trabajo para Mantenimiento" >
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="" value={form.From} label="Desde" setDate={(e) => { setForm({ ...form, From: e }) }} />
                </div>
                <div className="col-md-4">
                    <InputDate name="" value={form.Upto} label="Hasta" setDate={(e) => { setForm({ ...form, Upto: e }) }} />
                </div>
                <div className="col-md-4">
                    <SelectWorkMaintenanceOrderConstants idSelector={form.state} onChange={(e) => { setForm({ ...form, state: e }) }} label="Estado" />
                </div>
                <div className="col-md-6">
                    <SelectFixedAsset idSelector={form.idFixedAsset} onChange={(e) => { setForm({ ...form, idFixedAsset: e.IDFixedAsset }) }} label="Activo Fijo" returnType="Object" />
                </div>
                <div className="col-md-6">
                    <EditorFixedAssetItem idSelector={form.idItem} label="Item de Activo fijo" onChange={(e) => { setForm({ ...form, idItem: e.IDItem }) }} />
                </div>
                <div className="col-md-6">
                    <label>Guia de Mantenimiento</label>
                    <input type="text" className="form-control" value={form.procedureCode} onChange={(e) => { setForm({ ...form, procedureCode: e.target.value }) }} />
                </div>
                <div className="col-md-6">
                    <label>Codigo Interno</label>
                    <input type="text" className="form-control" value={form.internalCode} onChange={(e) => { setForm({ ...form, internalCode: e.target.value }) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={`Buscar`} />
                </div>
                <BasicTable
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />

            </div>
            <Modal modal={modalReplacement.modal} updateModal={modalReplacement.setModal} >
                <FixedAssetReplacementByWorkMaintenance idWorkMaintenanceOrder={bean.IDWorkMaintenanceOrder} />
            </Modal>
            <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={() => { updateWorkOrder(PENDING_FOR_REPLACEMENT) }} >
                <div className="row">
                    <div className="col-md-12">
                        <p>¿Desea solicitar implementos para orden de trabajo {bean.IDWorkMaintenanceOrder} {bean.ProcedureCode ? `- ${bean.ProcedureCode}` : ``}?</p>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalClose.modal} updateModal={modalClose.setModal} eventModal={() => { updateWorkOrder(COMPLETE) }} >
                <div className="row">
                    <div className="col-md-12">
                        <p>¿Desea Finalizar la orden de trabajo {bean.IDWorkMaintenanceOrder} {bean.ProcedureCode ? `- ${bean.ProcedureCode}` : ``}?</p>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={() => { updateWorkOrder(DELETED) }} >
                <div className="row">
                    <div className="col-md-12">
                        <p>¿Desea Eliminar la orden de trabajo {bean.IDWorkMaintenanceOrder} {bean.ProcedureCode ? `- ${bean.ProcedureCode}` : ``}?</p>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalCreate.modal} updateModal={modalCreate.setModal} eventModal={() => { createOrder() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>Observaciones</label>
                        <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }} />
                    </div>
                </div>
            </Modal>
            <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                <div className="row">
                    <div className="col-md-12">
                        <RequestMaintenance isModal filterProps={{ IDRequestMaintenance: bean.IDRequestMaintenance }} />
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}